import { render, staticRenderFns } from "./userabilitymodel.vue?vue&type=template&id=7b32a0bd&scoped=true"
import script from "./userabilitymodel.vue?vue&type=script&lang=js"
export * from "./userabilitymodel.vue?vue&type=script&lang=js"
import style0 from "./userabilitymodel.vue?vue&type=style&index=0&id=7b32a0bd&prod&scoped=true&lang=less"
import style1 from "./userabilitymodel.vue?vue&type=style&index=1&id=7b32a0bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b32a0bd",
  null
  
)

export default component.exports